export const colors = [
  {
    id: 1,
    dark: "#121212",
    light: "#ffffff",
    text: "Default",
  },
  {
    id: 2,
    dark: "#5c2b29",
    light: "#f28b82",
    text: "Red",
  },
  {
    id: 3,
    dark: "#614a19",
    light: "#fbbc04",
    text: "Yellow",
  },
  {
    id: 4,
    dark: "#345920",
    light: "#ccff90",
    text: "Green",
  },
  {
    id: 5,
    dark: "#16504b",
    light: "#aecbfa",
    text: "Blue",
  },
  {
    id: 6,
    dark: "#42275e",
    light: "#d7aefb",
    text: "Purple",
  },
];
